import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import { useApiClient, getUseManualHoursReportsKey } from '@/hooks'
import { ManualHoursReport, APIErrorResponse } from '@/types'
import { unwrapErrorResponse, unwrapResponse } from '@/utils'

export const usePostManualHoursReportDisapprove = ({
  id,
}: Pick<ManualHoursReport, 'id'>): UseMutationResult<
  ManualHoursReport,
  APIErrorResponse,
  unknown
> => {
  const client = useApiClient()
  const queryClient = useQueryClient()
  const hrListKey = getUseManualHoursReportsKey(true)

  return useMutation(
    (params) =>
      client
        .post(`/hours_reporting/hr/manual-hours/${id}/disapprove/`, params)
        .then(unwrapResponse)
        .catch(unwrapErrorResponse),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(hrListKey)
      },
    }
  )
}
